module.exports = __webpack_public_path__ + "img/seamless.bc5dc205.png";